<div class="image-selector" [class.single-mode]="isSingleMode()" [class.multiple-mode]="isMultipleMode()">
  <input
    #fileInput
    type="file"
    accept="image/jpeg,image/png"
    [multiple]="isMultipleMode()"
    (change)="onFileSelected($event)"
    style="display: none"
  />

  <!-- Single Mode -->
  @if (isSingleMode()) {
    <div class="drop-zone" role="button" tabindex="0"
      [attr.aria-label]="singlePreview() ? 'Change preview image' : 'Choose preview image'"
      (click)="triggerFileInput()"
      (keydown.enter)="$event.preventDefault(); triggerFileInput()"
      (keydown.space)="$event.preventDefault(); triggerFileInput()">
    <div class="placeholder placeholder--preview">
      <div class="placeholder-label">{{ effectiveButtonLabel() }}</div>

      @if (singlePreview(); as preview) {
        <button class="clear-all-btn" type="button"
          aria-label="Clear preview image" [disabled]="isUploading()"
          (click)="$event.stopPropagation(); clearImage()">
          <span class="material-symbols-outlined">close</span>
        </button>

          <div class="image-preview image-preview--square" aria-label="Selected preview image">
          <img class="image-preview__img" [src]="preview.url | secure | async" [alt]="preview.name" />
          <div class="image-preview__name">{{ preview.name }}</div>
          @if (isUploading()) {
            <div class="image-preview__loading">
              <mat-spinner diameter="24"></mat-spinner>
            </div>
          }
        </div>
      } 
      @else {
        <span class="material-symbols-outlined placeholder-icon">add</span>
        <div class="hint">Choose image</div>
      }
      </div>
    </div>
  }

  <!-- Multiple Mode-->
  @if (isMultipleMode()) {
    <div class="drop-zone wide" role="button" tabindex="0" 
      aria-label="Choose gallery images"
      (click)="triggerFileInput()"
      (keydown.enter)="$event.preventDefault(); triggerFileInput()"
      (keydown.space)="$event.preventDefault(); triggerFileInput()">
      <div class="placeholder placeholder--gallery">
        <div class="placeholder-label">{{ effectiveButtonLabel() }}</div>

        @if (previews().length) {
          <button type="button" class="clear-all-btn" aria-label="Clear all gallery images"
            [disabled]="uploadingCount() > 0" (click)="$event.stopPropagation(); clearAll()">
            <span class="material-symbols-outlined">close</span>
          </button>

          <div class="gallery-preview" aria-label="Selected gallery images">
            @for (preview of previews(); track preview.key; let idx = $index) {
              <div class="image-preview image-preview--thumb">
                <img class="image-preview__img" [src]="preview.url | secure | async" [alt]="preview.name" />
                <div class="image-preview__name">{{ preview.name }}</div>
                <button type="button" class="clear-image-btn"
                  [attr.aria-label]="'Remove image ' + preview.name"
                  (click)="$event.stopPropagation(); removeImage(idx)">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </div>
            }
          </div>

          @if (uploadingCount() > 0) 
          {
            <div class="uploading-indicator">
              <mat-spinner diameter="16"></mat-spinner>
              <span>Uploading {{ uploadingCount() }} image(s)...</span>
            </div>
          }
        } 
        @else 
        {
          <span class="material-symbols-outlined placeholder-icon">add</span>
          <div class="hint">Choose one or more images</div>
        }
      </div>
    </div>

    <div class="gallery-info">
      {{ previews().length }} / {{ maxImages() }} images
    </div>
  }

  @if (error(); as err) {
    <div class="error-message">{{ err }}</div>
  }
</div>
